/**
 * Base classes for the component.
 * @type {String}
 */
export const BASE_CLASSES = 'fit-tooltip';

/**
 * mouseLeave event listener name.
 * @type {String}
 */
export const MOUSE_LEAVE = 'mouseleave';

/**
 * Amound of secods to wait.
 * @type {Number}
 */
export const DELAY_MS = 1000;
